import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Form, Modal } from 'semantic-ui-react';
import { TextField } from '../common/FormFields';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import * as selectors from '../../redux/selectors';
import * as actions from '../../redux/actions';
import { bindActionCreators } from 'redux';
import { initialUserValues, userValidationSchema } from './admin.constants';
import * as _ from 'lodash';

export const AddUserDialogFromMenuItem = ({ addUser, userGroupId, userGroupOptions, loadUserGroups }) => {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState({ ...initialUserValues, userGroupId });

  const handleSubmit = user => {
    addUser(user);
    setUser(initialUserValues);
    setOpen(false);
  };

  useEffect(() => {
    if (!_.isEmpty(userGroupOptions)) {
      setUser({ ...user, userGroupId: userGroupOptions[0].value });
    }
  }, [userGroupOptions, user]);

  const handleClose = formik => {
    formik.resetForm();
    setOpen(false);
  };

  const handleOpen = formik => {
    loadUserGroups();
    formik.resetForm();
    setOpen(true);
  };

  return (
    <Formik initialValues={user} enableReinitialize validationSchema={userValidationSchema} onSubmit={handleSubmit}>
      {formik => (
        <Modal
          onClose={() => handleClose(formik)}
          onOpen={() => handleOpen(formik)}
          open={open}
          trigger={<Dropdown.Item icon="user outline" text="Add user" />}
        >
          <Modal.Header>Add user</Modal.Header>
          <Modal.Content>
            <Form widths="equal" onSubmit={formik.handleSubmit}>
              <TextField
                name="name"
                formik={formik}
                value={formik.values.name}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.name)}
                errorMessage={formik.errors.name}
                label="First and last name"
              />

              <TextField
                name="email"
                formik={formik}
                value={formik.values.email}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.email)}
                errorMessage={formik.errors.email}
                label="Email"
              />

              <Form.Field error={Boolean(formik.errors.userGroupId)}>
                <label htmlFor="userGroupId">Organization</label>
                <Dropdown
                  fluid
                  search
                  selection
                  clearable
                  options={userGroupOptions || []}
                  id="userGroupId"
                  data-testid="userGroupId"
                  label="User group"
                  name="userGroupId"
                  value={formik.values.userGroupId}
                  onChange={(e, d) => formik.setFieldValue(d.name, d.value)}
                />
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              type="submit"
              content="Create user"
              loading={formik.isSubmitting}
              onClick={formik.handleSubmit}
              positive
            />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  userGroupId: selectors.getCurrentAdminGroupId(state),
  userGroupOptions: state.admin.groupOptions,
});

const mapDispatchToProps = dispatch => ({
  addUser: bindActionCreators(actions.admin.addUser, dispatch),
  loadUserGroups: bindActionCreators(actions.admin.getGroups, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddUserDialogFromMenuItem);
